import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getNoVehicleImageToDisplay } from 'site-modules/shared/utils/get-no-vehicle-image-to-display';
import { Image } from 'site-modules/shared/components/image/image';
import { trackShowSilhouette } from 'site-modules/shared/utils/inventory/tracking';
import { TrackingConstant } from 'client/tracking/constant';

import './inventory-hero-carousel-image.scss';

export class InventoryHeroCarouselImage extends Component {
  static propTypes = {
    make: PropTypes.string,
    model: PropTypes.string,
    year: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    url: PropTypes.string,
    bodyType: PropTypes.string,
    isMobile: PropTypes.bool,
    vin: PropTypes.string,
    className: PropTypes.string,
  };

  static defaultProps = {
    make: '',
    model: '',
    year: '',
    url: '',
    vehicleType: '',
    isMobile: false,
    vin: '',
    bodyType: '',
    className: '',
  };

  state = {
    hasError: false,
    isLoading: true,
  };

  onError = () => {
    const { hasError } = this.state;
    if (!hasError) {
      trackShowSilhouette(TrackingConstant.SHOW_SILHOUETTE_ERROR, this.props.vin, this.props.url);
      this.setState({ hasError: true });
    }
  };

  onLoad = () => {
    this.setState({ isLoading: false });
  };

  render() {
    const { year, make, model, bodyType, isMobile, url, className } = this.props;
    const alt = year && make && model ? `The ${year} ${make} ${model}` : 'The vehicle';
    const errorImage = getNoVehicleImageToDisplay(bodyType);
    const { isLoading, hasError } = this.state;

    return (
      <Fragment>
        {isLoading && (
          <div className="inventory-hero-carousel-image loading-dots w-100 h-100 d-flex align-items-center justify-content-center">
            <span className="dot first" />
            <span className="dot second mx-1" />
            <span className="dot third" />
          </div>
        )}
        <Image
          className={classNames('static-slide d-block', className, {
            'w-100': isMobile,
            rounded: !isMobile,
          })}
          imageId={url}
          alt={alt}
          title={alt}
          key={url}
          errorImage={errorImage}
          source="static"
          onError={this.onError}
          onLoad={this.onLoad}
        />
        {hasError && (
          <div className="pos-a text-gray-darker fw-bold w-100 text-center" style={{ top: '83%' }}>
            Photos not available
          </div>
        )}
      </Fragment>
    );
  }
}
